import About from "pages/About";
import Blogs from "pages/Blogs";
import Contact from "pages/Contact";
import Features from "pages/Features";
import Home from "pages/Home";
import PrivacPolicy from "crm/other/Privacy Policy";
import { Routes, Route } from "react-router-dom";
import Privacy from "pages/Privacy";
import TermsAndConditions from "pages/TermsAndConditions";
import Blog from "crm/other/Blog";
import BlogPost from "crm/other/BlogPost";


export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blog />} />
            {/* FIXED ROUTE */}
            <Route path="/blog/:title" element={<BlogPost />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termsAndConditions" element={<TermsAndConditions />} />
        </Routes>

    );
}
